import { Routes, Route } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client';
import { ThemeProvider } from '@emotion/react';

// others
import Products from './pages/Products';
import Home from './pages/Home';
import NotFound from './pages/NotFound';
import useApolloClient from './hooks/useApolloClient';
import theme from './utils/theme';
import CartContext from './contexts/CartContext';
import useCart from './hooks/useCart';

const App = () => {
  const { client } = useApolloClient();
  const cartItems = useCart();

  return (
    <ThemeProvider theme={theme}>
      <CartContext.Provider value={cartItems}>
        <ApolloProvider client={client}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="men" element={<Products />} />
            <Route path="women" element={<Products />} />
            <Route path="collections" element={<Products />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </ApolloProvider>
      </CartContext.Provider>
    </ThemeProvider>
  );
};

export default App;
